<template>
  <div class="account">
    <Loading v-if="this.loading" />
    <v-layout v-else column align-center justify-center>
      <v-card
        elevation="4"
        min-width="500"
        max-width="1000"
        class="mx-auto mt-12 mb-5 px-10"
      >
        <v-card-title>Upgrade to Latest ARD Version</v-card-title>

        <hr />
        <br />

        <v-card-text v-if="user_details.admin && !account_details.use_latest">
          The latest ARD version includes changes to tile metadata and new mask
          files that could impact your work. Read the
          <a
            href="https://ard.maxar.com/docs/releases/releases/"
            target="_blank"
            >Release Announcement</a
          >
          for details. To switch back to the legacy version after upgrading,
          email ard-support@maxar.com. <br /><br />Once you're ready, check the
          box below and then click the "upgrade"

          <v-checkbox
            v-model="checkbox"
            :rules="[(v) => !!v || 'You must agree to continue!']"
            label="I'm ready to upgrade"
            required
          ></v-checkbox>

          <v-row
            ><v-layout justify-center>
              <v-btn
                :disabled="!checkbox"
                class="ma-4 button_text--text"
                elevation="4"
                color="primary"
                @click="useLatest()"
              >
                Upgrade
              </v-btn>
            </v-layout></v-row
          >
        </v-card-text>

        <v-card-text v-else-if="thank_you">
          Thank you for upgrading to the latest ARD version. If you have any
          questions please email ard-support@maxar.com.
        </v-card-text>

        <v-card-text v-else-if="account_details.use_latest">
          Your account has already been upgraded to the latest ARD version.
        </v-card-text>

        <v-card-text v-else>
          Please contact your account administrator to upgrade to the latest ARD
          version.
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loading from "@/components/shared/Loading.vue";

export default {
  data() {
    return {
      checkbox: false,
      loading: true,
      use_latest_url: "",
      thank_you: false,
    };
  },
  components: { Loading },
  computed: {
    ...mapGetters(["user_details", "account_details"]),
  },
  mounted() {
    this.waitThenRoute();
  },
  methods: {
    waitThenRoute() {
      if (this.user_details.account_id) {
        this.loading = false;
        this.use_latest_url =
          "https://" +
          process.env.VUE_APP_ARD_DOMAIN +
          "/admin/account/" +
          this.user_details.account_id +
          "/use_latest?value=true";
      } else {
        setTimeout(this.waitThenRoute, 200);
      }
    },
    useLatest() {
      this.loading = true;
      return axios
        .post(this.use_latest_url)
        .then(() => {
          this.loading = false;
          this.account_details.use_latest = true;
          this.thank_you = true;
        })
        .catch((error) => {
          this.loading = false;
          return error;
        });
    },
  },
};
</script>
<style lang="scss">
.v-application .error--text {
  color: #df323b !important;
}
</style>
